import { render, staticRenderFns } from "./OssList.vue?vue&type=template&id=43ce28df&"
import script from "./OssList.vue?vue&type=script&lang=js&"
export * from "./OssList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports